<template>
  <a-card hoverable
          class="cardStyle"
          @mouseenter="mouseFunc.customizeEnter"
          @mouseleave="mouseFunc.customizeLeave">
    <template #cover>
      <div class="cardStyle-image"
           @click="mouseFunc.detailItem(spu)">
        <img v-show="customizeViewerType"
             :src="toUrl(
              customableImageService?.findCustomableImage(
                currentColor,
                exampleCustomableImage
              )!)" />
        <img v-show="!customizeViewerType"
             :src="toUrl(spu.image)" />
      </div>
      <div v-show="availableColors"
           class="cardStyle-cardColor">
        <div class="cardStyle-cardColor-iconClass cardStyle-cardColor-leftIcon"
             style="color: #ffffff"
             @click="mouseFunc.colorChoose('left')" />
        <div ref="colorRef"
             class="cardStyle-cardColor-colorBox">
          <template v-for="(color, index) in availableColors"
                    :key="index">
            <div :class="['cardStyle-cardColor-colorBox-box', currentColor && currentColor.value === color.value ? 'active' : '']"
                 @click="mouseFunc.colorClick($event, color)">
              <div class="cardStyle-cardColor-colorBox-box-image"
                   :style="{ background: color.value, backgroundImage: `url(${color.alt_image}?x-oss-process=image/resize,w_30/quality,q_60)` }" />
            </div>
          </template>
        </div>
        <div class="cardStyle-cardColor-iconClass cardStyle-cardColor-rightIcon"
             style="color: #8f8484"
             @click="mouseFunc.colorChoose('right')" />
      </div>
    </template>
    <a-card-meta :title="spu.name"
                 class="cardBox">
      <template #description>
        <div class="cardStyle-cardDesc">
          <span class="cardStyle-cardDesc-priceDesc"
                :style="{
                  flex: baseDiscount.clothing.value != 100 ? 'none' : '0.9'
                }">
            <span v-if="baseDiscount.clothing.value != 100"
                  class="discountSellPrice">¥{{ calculateDiscount("clothing", spu.price)
                  }}<span class="start-price"> {{ $t('shop.CategoriesCardPage.start') }}</span></span>
            <span :class="baseDiscount.clothing.value != 100 ? 'discountPrice' : ''">¥{{ spu.price }}<span
                    class="start-price"> </span></span>
            <span v-if="baseDiscount.clothing.name != $t('shop.CategoriesCardPage.originalPrice')"
                  class="discountText">
              <span>{{ baseDiscount.clothing.name }}</span>
            </span>
          </span>
          <span class="cardStyle-cardDesc-sellDesc">
            {{ $t('shop.CategoriesCardPage.sale') }} {{ spu.sale_count }}
            <shopping-cart-outlined class="shoppingIcon"
                                    @click="addCart(spu.id)" />
          </span>
        </div>
        <div mode="out-in">
          <div v-show="!operationType"
               class="cardStyle-cardContent">
            <div class="descTitle">{{ spu.desc }}</div>
            <div v-if="temporaryMaterial"
                 class="descMaterial">
              <div class="leftTitle">
                <span class="icon"
                      :style="{
                        background: `url(${materialIcon}) no-repeat`,
                        backgroundSize: `contain`
                      }" />
                <span class="title">{{ $t('shop.CategoriesCardPage.material') }}</span>
              </div>
              <div class="rightBox">
                <span>{{ temporaryMaterial }}</span>
              </div>
            </div>
            <div v-if="spu.deliver">
              <div class="leftTitle deliverTitle">
                <span class="icon"
                      :style="{
                        background: `url(${deliveryIcon}) no-repeat`,
                        backgroundSize: `contain`,
                        height: `12px`
                      }" />
                <span class="title">{{ $t('shop.CategoriesCardPage.deliveryTime') }}</span>
              </div>
              <div class="rightBox">
                <span>{{ spu.deliver + $t('shop.CategoriesCardPage.hour') || $t('shop.CategoriesCardPage.none')
                }}</span>
              </div>
            </div>
            <div v-if="temporarySize"
                 class="descMaterial">
              <div class="leftTitle">
                <span class="icon"
                      :style="{
                        background: `url(${sizeIcon}) no-repeat`,
                        backgroundSize: `contain`
                      }" />
                <span class="title">{{ $t('shop.CategoriesCardPage.size') }}</span>
              </div>
              <div class="rightBox">
                <span>{{ temporarySize }}</span>
              </div>
            </div>
          </div>
          <div v-show="operationType"
               class="cardStyle-cardContent cardStyle-cardOperate">
            <a-button type="primary"
                      @click="mouseFunc.designClick(spu)">
              {{ $t('shop.CategoriesCardPage.startDesign') }}
            </a-button>
            <a-button @click="mouseFunc.detailItem(spu)">
              {{ $t('shop.CategoriesCardPage.detailItem') }}
            </a-button>
            <a-button @click="mouseFunc.detailComment(spu)">
              {{ $t('shop.CategoriesCardPage.detailComment') }}
            </a-button>
          </div>
        </div>
      </template>
    </a-card-meta>
  </a-card>
  <a-modal v-model:visible="detailVisible"
           width="838px"
           class="fb-card-detail"
           :title="$t('shop.CategoriesCardPage.productDetails')"
           :footer="null">
    <div class="images">
      <a-image v-for="(item, index) in imageTempArray"
               :key="index"
               :preview="false"
               :src="item.image" />
    </div>
  </a-modal>
  <ShoppingCartModal ref="shoppingCart" />
  <a-modal v-model:visible="loginVisible"
           :footer="null"
           :width="450">
    <iota-simple-signin :options="{ newWindowToResetPassword: true }"
                        @success="loginSuccess" />
  </a-modal>
</template>

<script setup lang="ts">
import { CUSTOMABLE_IMAGE_SERVICE, type CustomableImageService } from '../../custom-spus/service/CustomableImageService'
import type { AccountInfoOption } from '../../custom-spus/index'
import type { AccountInfoService } from '../../account-info/index'
import { CORE_ROUTER, CORE_USER, type UserService } from "@/core"
import type { Plugin } from "@/plugins"
import { PLUGIN_ACCOUNT_INFO } from "@/plugins/builtin/BuiltinPluginSymbol"
import { toUrl } from "@/utils"
import { container } from "tsyringe"
import { computed, nextTick, onMounted, ref } from "vue"
import type { Router } from "vue-router"
import { sortBy } from "../../custom-spus/utils"
import ShoppingCartModal from "../../custom-spus/view/components/ShoppingCartModal.vue"
import { spusDetail } from "../api/categories"
import type { categoriesDetailState } from "../api/interface/categoriesInterface"
import deliveryIcon from "../assets/ic-delivery.png"
import materialIcon from "../assets/ic-material.png"
import sizeIcon from "../assets/ic-size.png"

const discountStore =
  container.resolve<Plugin<AccountInfoOption, AccountInfoService>>(
    PLUGIN_ACCOUNT_INFO
  )
const { calculateDiscount } = discountStore.service
const { baseDiscount } = discountStore.options

// declare Function
const props = defineProps<{
  spu: categoriesDetailState
  isHome: boolean
}>()

const loginVisible = ref<boolean>(false)
const spuId = ref<number>(0)
const loginSuccess = () => {
  loginVisible.value = !loginVisible.value
  openCart(spuId.value)
}
// declare Initialize Core
const availableColors = ref<any[]>([])
const currentColor = ref<any>()

const exampleCustomableImage = ref()
if (
  Array.isArray(props.spu.customableImages) &&
  props.spu.customableImages.length > 0
) {
  exampleCustomableImage.value = Object.assign(
    {},
    props.spu.customableImages[0]
  )
}

const temporarySize = computed((): string | undefined => {
  const sizeFilter = props.spu.attrs.find((item) => {
    return item.attribute.key === "size"
  })
  return sizeFilter?.value
})

const temporaryMaterial = computed((): string | undefined => {
  const materialFilter = props.spu.attrs.find((item) => {
    return item.attribute.key === "material"
  })
  return materialFilter?.value
})

// declare Type
const router = container.resolve<Router>(CORE_ROUTER)
const operationType = ref<boolean>(false)
const detailVisible = ref<boolean>(false)
const imageTempArray = ref<categoriesDetailState["images"]>()
const colorRef = ref()

const customableImageService = ref<CustomableImageService>()
onMounted(() => {
  customableImageService.value = container.resolve<CustomableImageService>(
    CUSTOMABLE_IMAGE_SERVICE
  )
  let colors: any[] = []
  const attrs = props.spu.attrs || []

  const colorAttr = attrs.find((attr) => {
    return attr.attribute.key === "color"
  })

  if (colorAttr) {
    if (colorAttr.object_value) {
      colorAttr.object_value.forEach((item: any) => {
        const matchedImage = props.spu.customableImages[0].altImages.find((image) => {
          return image.attrs[0].object_value.value === item.value
        })
        colors.push({
          value: item.value,
          name: item.name,
          alt_image: matchedImage ? matchedImage.alt_image : undefined
        })
      })
    } else {
      const colorsEnum = colorAttr.value || ""
      const strColors = colorsEnum.split(",") || []
      colors = strColors
        .map((c) => {
          return customableImageService.value?.convertColor(c)
        })
        .filter((c) => c !== undefined) as any[]
    }
  }
  availableColors.value = colors.sort(sortBy("value", false))
})

const customizeViewerType = ref<boolean>(false)
// declare Method
const mouseFunc = {
  customizeEnter: () => {
    customizeViewerType.value = true
    operationType.value = true
  },
  customizeLeave: () => {
    customizeViewerType.value = false
    operationType.value = false
  },
  /** 选择衣服颜色 */
  colorChoose: (item: "left" | "right") => {
    const calcNumber = item === "right" ? 30 : -30
    colorRef.value.scrollTo({
      left: colorRef.value.scrollLeft + calcNumber,
      behavior: "smooth"
    })
  },
  /** 衣服介绍（卡片） */
  colorClick: (event: Event, color: any) => {
    if (currentColor.value && color.value === currentColor.value.value) {
      currentColor.value = null
      return
    }
    currentColor.value = color
  },
  /** 开始设计衣服 */
  designClick: (item: categoriesDetailState): void => {
    const { id, category_id } = item
    router.push({
      path: "/products/custom_spus_design",
      query: { spuId: id, categoryId: category_id }
    })
  },
  /** 查看产品介绍（商品详情） */
  detailItem: (item: categoriesDetailState): void => {
    detailVisible.value = true
    imageTempArray.value = item.images
  },
  detailComment: (item: categoriesDetailState): void => {
    if (props.isHome) {
      router.push({
        path: `/product/comment/${item.id}`,
        query: { categoryId: item.category_id }
      })
    } else {
      router.push({
        path: `/console/products/spus/comment/${item.id}`,
        query: { categoryId: item.category_id }
      })
    }
  }
}

const shoppingCart = ref<any>()
// 加入购物车
const addCart = async (id: any) => {
  const userService = container.resolve<UserService>(CORE_USER)
  const user = userService.getUser()
  spuId.value = id
  if (Object.entries(user.value).length < 1) {
    loginVisible.value = true
    return
  }
  openCart(id)
}
const openCart = async (id: any) => {
  const res = await spusDetail(id)
  const data = {
    is_custom: false,
    spu_id: res.id,
    image: props.spu.customableImages,
    skus: res.skus,
    customizedImages: null,
    name: "",
    spu_name: res.name,
    custom_spu_id: null,
    price_detail: {
      spu_price: props.spu.price
    }
  }
  shoppingCart.value.show()
  nextTick(() => {
    shoppingCart.value.setProduct(data)
  })
}
</script>

<style lang="less" scoped>
.cardStyle {
  margin: 15px 18px 40px 20px;
  height: 600px;
  width: 330px;
  user-select: none;

  &:nth-child(4n+1) {
    margin-left: 20px !important;
  }

  &:nth-child(n+2) {
    margin-left: 40px;
  }


  :deep(.ant-card-cover) {
    margin: 0;
    position: relative;
  }

  :deep(.ant-card-body) {
    display: flex;
    // padding: 20px 0 0 16px;
    padding: 0;

    .cardBox {
      width: 100%;
    }
  }

  .cardStyle-image {
    width: 280px;
    height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &-cardColor {
    display: flex;
    height: 55px;
    transition: 0.3s linear;
    position: absolute;
    background: url(../assets/cardColorBg.png) no-repeat;
    background-size: cover;
    justify-content: center;
    align-items: flex-end;
    bottom: 0;
    scrollbar-width: none;

    &-colorBox {
      width: 280px;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
      transition: 0.3s linear;
      scrollbar-width: none;

      &-box {
        transition: 0.3s linear;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-size: cover;
        border-radius: 2px;
        margin-left: 4px;
        margin-right: 1px;
        border: 1px solid #d7d7d7;

        &-image {
          width: 100%;
          height: 100%;
          background-size: cover !important;
        }
      }

      .active {
        border: 2px solid #373737;
      }
    }

    &-colorBox::-webkit-scrollbar {
      display: none;
    }

    &-iconClass {
      width: 12px;
      height: 12px;
      margin-bottom: 10px;
    }

    &-leftIcon {
      background: url("../../home/assets/imgs/ic-left_lined.png") no-repeat;
      background-size: contain;
      margin-right: 10px;
      margin-left: 10px;
    }

    &-rightIcon {
      background: url("../../home/assets/imgs/ic-right_lined.png") no-repeat;
      background-size: contain;
      float: right;
      margin-right: 10px;
      margin-left: 10px;
    }
  }

  &-cardColor::-webkit-scrollbar {
    display: none;
  }

  &-cardContent {
    height: fit-content;
    width: 95%;
    padding-left: 14px;

    .descMaterial {
      -webkit-line-clamp: 2;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
    }

    div {
      margin-top: 5px;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;

      .leftTitle {
        flex: 0.3;

        .icon {
          background-size: contain;
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-top: 2px;
        }

        .title {
          margin-left: 5px;
          margin-right: 5px;
          font-size: 14px;
          color: #111111;
          line-height: 20px;
        }
      }

      .deliverTitle {
        flex: 0.5 !important;
      }

      .rightBox {
        flex: 1;
      }
    }

    .descTitle {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      height: 40px;
    }
  }

  &-cardOperate {
    display: flex;
    width: 100%;
    margin-top: 60px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0px;

    .ant-btn {
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      height: 32px;
      border-radius: 4px;
      margin-top: 8px;
      font-family: "Microsoft YaHei";
      font-size: 14px;
      line-height: 22px;
      height: 40px;
      width: 90%;
      margin-top: 0;
      margin-right: 0;
    }

    .ant-btn:first-child {
      background-color: #111111;
      color: #ffffff;
    }

    .ant-btn:not(:first-child) {
      color: #999999;
      margin-top: 10px;
    }
  }

  &-cardDesc {
    display: inline-flex;
    align-items: center;
    padding-left: 16px;
    width: 100%;

    &-descTitle {
      height: 50px;
    }

    &-priceDesc {
      font-size: 14px;
      font-family: "Microsoft YaHei Bold";
      color: #de4a09;
      line-height: 22px;
      display: inline-flex;
      align-items: baseline;
      flex: 0.9;

      .discountSellPrice {
        float: left;
        font-size: 20px;
        color: red;
      }

      .discountPrice {
        text-decoration: line-through;
        float: left;
      }

      .discountText {
        display: inline-flex;
        background: #fae4da;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 20px;

        span {
          color: #de4a09 !important;
          font-size: 14px;
          font-family: "Microsoft YaHei";
        }
      }

      span:not(:first-child) {
        margin-left: 8px;
      }
    }

    &-sellDesc {
      font-size: 14px;
      color: #999999;
      font-family: "Microsoft YaHei";
      line-height: 22px;
      padding-left: 35px;

      .shoppingIcon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        font-size: 16px;
        background: #f6f6f6;
      }
    }
  }

  &-cart {
    float: right;
    font-size: 18px;
    line-height: 22px;
    margin-right: 20px;
  }

  :deep(.ant-card-meta-title) {
    font-family: "Microsoft YaHei Bold";
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 20px 0 0 16px;
  }
}

.images {
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
</style>

<style lang="less">
.fb-card-detail {
  top: 5vh;
  height: 90vh;
  bottom: 20px;
  padding-bottom: 0;

  .ant-modal-body {
    height: calc(100% - 56px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .ant-modal-content {
    height: 100%;
  }
}

.start-price {
  font-size: 14px;
  color: #999999;
  display: inline-block;
  font-family: "Microsoft YaHei";
  margin-left: 5px;
  transform-origin: 0 1;
}
</style>
